function HalfSplashScreen() {
  return (
    <div className="auth-half-splash-screen">
      <div>
        <h1>
          Commission
          <br />
          Statement
          <br />
          Extraction Tool
        </h1>
        <h4>By Blitz Cloud Services</h4>
      </div>
    </div>
  );
}

export default HalfSplashScreen;
